module.exports = __webpack_public_path__ + "img/icon-occur.3fad3542.svg";